import { render, staticRenderFns } from "./upgradeEdm.vue?vue&type=template&id=2a4a0aca&"
import script from "./upgradeEdm.vue?vue&type=script&lang=js&"
export * from "./upgradeEdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports